import { window } from '../../globals';
import {
  canAccessIssueOverview,
  canAccessProjectIssueOverview,
  isIssueOverviewEnabled,
} from '../../../shared/permissions/issueOverview';
import { isQualityEnabled, isSecurityEnabled } from '../../helpers/features';

/** Returns wether the current org has the Issue Overview feature enabled. */
export const orgHasIssueOverviewEnabled = (): boolean =>
  isIssueOverviewEnabled({
    access_level: window.user?.organization?.access_level ?? 'free',
    flags: (window.enabledFeatureFlags ?? []).map(({ flag }) => flag),
    on_prem: window.on_prem,
    stripe_plan: window.user?.organization?.stripe_plan,
  });

/** Returns whether the current user can access the issue overview, with an optional project ID context */
export const userHasIssueOverviewPermissions = (projectId?: string): boolean => {
  const hasSecurity = isSecurityEnabled();
  const hasQuality = isQualityEnabled();
  return (
    !!window.user?.permissions &&
    (projectId
      ? canAccessProjectIssueOverview(
        window.user?.permissions,
        projectId,
        hasSecurity,
        hasQuality,
      )
      : canAccessIssueOverview(window.user?.permissions, hasSecurity, hasQuality))
  );
};
